import { BillingCode } from 'src/participantHistory/intakeNote/billingCodeConstants'
import { z } from 'zod'

const MAX_INPUT_LENGTH = 3000

export const INTAKE_NOTE_PSYCHIATRY_FORM_SCHEMA = z.object({
  date: z.string(),
  visitTypeRemote: z.boolean().refine((val) => val, 'Only remote visits'),
  chiefConcern: z.string().max(MAX_INPUT_LENGTH),
  currentMediciationsSupplementsAndVitamins: z.string().max(MAX_INPUT_LENGTH),
  pastMedications: z.string().max(MAX_INPUT_LENGTH),
  sideEffects: z.string().max(MAX_INPUT_LENGTH),
  allergies: z.string().max(MAX_INPUT_LENGTH),
  physicalAppearance: z.string().max(MAX_INPUT_LENGTH),
  hpi: z.string().max(MAX_INPUT_LENGTH),
  psychiatricHistory: z.object({
    traumaHistory: z.string().max(MAX_INPUT_LENGTH),
    postTraumaticStressSymptoms: z.string().max(MAX_INPUT_LENGTH),
    anxietySymptoms: z.string().max(MAX_INPUT_LENGTH),
    moodSymptoms: z.string().max(MAX_INPUT_LENGTH),
    depressionAndManicSymptoms: z.string().max(MAX_INPUT_LENGTH),
    lethalityRisk: z.string().max(MAX_INPUT_LENGTH),
    psychoticSymptoms: z.string().max(MAX_INPUT_LENGTH),
    sleepPatterns: z.string().max(MAX_INPUT_LENGTH),
    appetiteAndNutrition: z.string().max(MAX_INPUT_LENGTH),
    sensoryPerceptions: z.string().max(MAX_INPUT_LENGTH),
    attentionDeficitSymptoms: z.string().max(MAX_INPUT_LENGTH),
  }),
  socialAndFunctionalHistory: z.object({
    educationEmploymentStatus: z.string().max(MAX_INPUT_LENGTH),
    substanceUseHistory: z.string().max(MAX_INPUT_LENGTH),
    medicalHistory: z.string().max(MAX_INPUT_LENGTH),
    familyPsychiatricHistory: z.string().max(MAX_INPUT_LENGTH),
  }),
  therapeuticInterventions: z.string().max(MAX_INPUT_LENGTH),
  lifestyleRecommendations: z.string().max(MAX_INPUT_LENGTH),
  followUpPlan: z.string().max(MAX_INPUT_LENGTH),
  mentalStatusExamination: z.string().max(MAX_INPUT_LENGTH),
  clinicalImpression: z.string().max(MAX_INPUT_LENGTH),
  BILLING_CODES: z.array(z.nativeEnum(BillingCode)).min(1, 'At least one billing code is required').default([]),
})

export type IntakeNotePsychiatryFormType = z.infer<typeof INTAKE_NOTE_PSYCHIATRY_FORM_SCHEMA>
